import styled from 'styled-components'
import DatePicker from 'components/DatePicker'

export default styled(DatePicker)``
